//用于判断是不是杰峰的设备
export const startsWithExcludedString = (inputString) => {
  if (!inputString) return;
  //是JF返回true，不是则返回false，可设置多个平台前缀
  let excludedStrings = ['JF_'];
  for (let excludedString of excludedStrings) {
    if (inputString.startsWith(excludedString)) {
      return true;
    }
  }

  return false;
};

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /android|iPhone|iPad|iPod|blackberry|windows phone|mobile/i.test(
    userAgent,
  );
}

//判断设备类型前缀
export function getPrefix(str) {
  if (!str) return '';
  // 使用正则表达式匹配前缀
  const match = str.match(/^[^_]+_/);
  return match ? match[0] : ''; // 如果匹配成功，返回前缀，否则返回空字符串
}

//base64转Babel
export function base64ToBlob(base64String, mimeType = 'image/jpeg') {
  // 去除 data URL 前缀（如果存在）
  let base64Data = base64String;
  if (base64Data.startsWith('data:')) {
    const commaIndex = base64Data.indexOf(',');
    if (commaIndex !== -1) {
      base64Data = base64Data.substring(commaIndex + 1);
    }
  }

  // 验证 Base64 字符串的有效性
  try {
    const byteCharacters = atob(base64Data);
    const byteArrays = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArrays[i] = byteCharacters.charCodeAt(i);
    }

    // 创建 Blob 对象
    return new Blob([byteArrays], { type: mimeType });
  } catch (error) {
    console.error('Failed to decode Base64 string:', error);
    throw error;
  }
}
//获取元素的宽高
export function getElementSize(elementId) {
  var element = document.getElementById(elementId);
  if (element) {
    return {
      height: element.offsetHeight,
      width: element.offsetWidth,
    };
  } else {
    console.error('Element not found with ID:', elementId);
    return null; // 如果元素不存在，返回 null
  }
}